/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface ListLoyaltyPromotions200ResponsePromotionsInner
 */
export interface ListLoyaltyPromotions200ResponsePromotionsInner {
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizeId?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizeDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizeRedeemDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizeRedemed?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizePointsNeeded?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizePrintQty?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizePrintMax?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizeLimit?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizeType?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizeNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    endTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    disclaimerId?: string;
    /**
     * 
     * @type {string}
     * @memberof ListLoyaltyPromotions200ResponsePromotionsInner
     */
    prizeValue?: string;
}


/**
 * Check if a given object implements the ListLoyaltyPromotions200ResponsePromotionsInner interface.
 */
export function instanceOfListLoyaltyPromotions200ResponsePromotionsInner(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function ListLoyaltyPromotions200ResponsePromotionsInnerFromJSON(json: any): ListLoyaltyPromotions200ResponsePromotionsInner {
    return ListLoyaltyPromotions200ResponsePromotionsInnerFromJSONTyped(json, false);
}

export function ListLoyaltyPromotions200ResponsePromotionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLoyaltyPromotions200ResponsePromotionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'prizeId': !exists(json, 'prizeId') ? undefined : json['prizeId'],
        'prizeDescription': !exists(json, 'prizeDescription') ? undefined : json['prizeDescription'],
        'prizeRedeemDate': !exists(json, 'prizeRedeemDate') ? undefined : json['prizeRedeemDate'],
        'prizeRedemed': !exists(json, 'prizeRedemed') ? undefined : json['prizeRedemed'],
        'prizePointsNeeded': !exists(json, 'prizePointsNeeded') ? undefined : json['prizePointsNeeded'],
        'prizePrintQty': !exists(json, 'prizePrintQty') ? undefined : json['prizePrintQty'],
        'prizePrintMax': !exists(json, 'prizePrintMax') ? undefined : json['prizePrintMax'],
        'prizeLimit': !exists(json, 'prizeLimit') ? undefined : json['prizeLimit'],
        'prizeType': !exists(json, 'prizeType') ? undefined : json['prizeType'],
        'prizeNotes': !exists(json, 'prizeNotes') ? undefined : json['prizeNotes'],
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'startTime': !exists(json, 'startTime') ? undefined : json['startTime'],
        'endTime': !exists(json, 'endTime') ? undefined : json['endTime'],
        'disclaimerId': !exists(json, 'disclaimerId') ? undefined : json['disclaimerId'],
        'prizeValue': !exists(json, 'prizeValue') ? undefined : json['prizeValue'],
    };
}

export function ListLoyaltyPromotions200ResponsePromotionsInnerToJSON(value?: ListLoyaltyPromotions200ResponsePromotionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'prizeId': value.prizeId,
        'prizeDescription': value.prizeDescription,
        'prizeRedeemDate': value.prizeRedeemDate,
        'prizeRedemed': value.prizeRedemed,
        'prizePointsNeeded': value.prizePointsNeeded,
        'prizePrintQty': value.prizePrintQty,
        'prizePrintMax': value.prizePrintMax,
        'prizeLimit': value.prizeLimit,
        'prizeType': value.prizeType,
        'prizeNotes': value.prizeNotes,
        'startDate': value.startDate,
        'endDate': value.endDate,
        'startTime': value.startTime,
        'endTime': value.endTime,
        'disclaimerId': value.disclaimerId,
        'prizeValue': value.prizeValue,
    };
}

